/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable, Optional } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ConfigService } from './config.service';
import * as moment from 'moment';

/**
 * This service is used for detect specific path or device, 4 setup the title of the page and define the theme.
 */

@Injectable()
export class RoutingService {
  params: any;
  theme: string;
  mobile = navigator.userAgent.match(
    /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i,
  );
  private baseHrefOffset: number;

  constructor(
    private titleService: Title,
    public config: ConfigService,
    @Optional() @Inject(APP_BASE_HREF) private baseHref: string,
  ) {
    this.baseHrefOffset = (this.baseHref || '/')
      .split('/')
      .filter((segment) => segment.length > 0).length;
  }

  /**
   * Get a path segment accounting for base href offset.
   * Use this instead of location.pathname.split('/')[index]
   */
  getPathSegment(index: number): string {
    return location.pathname.split('/')[index + this.baseHrefOffset] || '';
  }

  isLogin() {
    return this.getPathSegment(1) === 'login';
  }
  isHomepage() {
    return this.getPathSegment(2) === 'home';
  }
  isScanner() {
    return this.getPathSegment(4) === 'scanner';
  }
  isStories() {
    return this.getPathSegment(2) === 'stories';
  }
  isSearch() {
    return this.getPathSegment(3) === 'search';
  }
  isMarket() {
    return this.getPathSegment(3) === 'market';
  }
  isFolio() {
    return (
      this.getPathSegment(2) === 'portfolio' ||
      this.getPathSegment(3) === 'portfolio'
    );
  }
  isHot() {
    return this.getPathSegment(3) === 'trending';
  }
  isQuery() {
    return this.getPathSegment(3) === 'query';
  }
  isInvest() {
    return this.getPathSegment(2) === 'invest';
  }
  isMain() {
    return this.getPathSegment(4) === 'main';
  }
  isChart2() {
    return this.getPathSegment(4) === 'chart2';
  }
  isChart() {
    return this.getPathSegment(4) === 'chart';
  }

  isMulti() {
    return this.getPathSegment(4) === 'multi';
  }
  isRadar() {
    return this.getPathSegment(4) === 'radar';
  }

  isNewsaudit() {
    return this.getPathSegment(4) === 'audit';
  }
  isNewsletter() {
    return this.getPathSegment(2) === 'newsletter';
  }
  isPreview() {
    return this.getPathSegment(3) === 'preview';
  }

  isPath(value) {
    return this.getPathSegment(1) === value;
  }
  isReport() {
    return this.getPathSegment(2) === 'report';
  }
  isMobile() {
    return (
      this.getPathSegment(1) === 'mobile' ||
      this.mobile ||
      window.innerWidth <= 700
    );
  }
  isFeed() {
    return (
      this.getPathSegment(2) === 'newsfeed' ||
      this.getPathSegment(3) === 'newsfeed' ||
      this.getPathSegment(4) === 'newsfeed'
    );
  }
  isTrending() {
    return this.getPathSegment(1) === 'trending';
  }
  isChat() {
    return this.getPathSegment(2) === 'chat';
  }
  isIframe() {
    return (
      this.getPathSegment(1) === 'iframe' || this.getPathSegment(1) === 'widget'
    );
  }
  isWidget() {
    return this.getPathSegment(1) === 'widget';
  }
  isReader() {
    return this.getPathSegment(2) === 'reader';
  }
  isStoryReader() {
    return this.getPathSegment(2) === 'story';
  }
  isDev() {
    return this.config.appConfig && this.config.appConfig.environment === 'dev';
  }
  isProd() {
    return (
      this.config.appConfig && this.config.appConfig.environment === 'prod'
    );
  }
  isApp() {
    return (
      this.config.appConfig && this.config.appConfig.routing.project === 'app'
    );
  }

  getTitle() {
    const title = 'Yukka | Realtime News-Analytics';
    this.titleService.setTitle(title);
  }
  reFresh(oldp, newp, goin) {
    if (!newp) {
      return true;
    }
    let shouldRefresh = false;
    goin.forEach((item) => {
      if (oldp[item] !== newp[item]) {
        shouldRefresh = true;
        return;
      }
    });
    return shouldRefresh;
  }
  inTheme(theme: string) {
    let resolved = Array.isArray(theme) ? theme[0] : theme;
    if (
      !resolved ||
      resolved === 'yukka' ||
      (resolved !== 'dark' && resolved !== 'light')
    ) {
      resolved = 'dark';
    }
    this.theme = resolved;
    if (this.config.appConfig.setup.useStorage) {
      localStorage.setItem('theme', this.theme);
    }
    document.querySelector('body').className = '';
    document.querySelector('body').className = 'theme-' + this.theme;
  }
  isToday(value) {
    if (value && isNaN(value)) {
      const date = value.split('--');
      return (
        moment().format('YYYY-MM-DD') <= moment(date[1]).format('YYYY-MM-DD')
      );
    }
    return true;
  }
}
